<template>
    <a-modal
        :visible="true"
        :width="'70vw'"
        :footer="null"
        :closable="false"
        :destroy-on-close="true"
        centered
        wrap-class-name="poh-wrap"
        @cancel="$emit('close')"
    >
        <div class="poh-modal">
            <div class="poh-head">
                <div>
                    <h3>Histórico de compra</h3>
                    <div class="poh-sub" v-if="product_name">{{ product_name }}</div>
                </div>
                <button class="poh-x" @click="$emit('close')">
                    <span class="material-icons-outlined">close</span>
                </button>
            </div>

            <cc-loader-full v-if="loading" />

            <div class="poh-body" v-else>
                <a-table
                    size="small"
                    :columns="columns"
                    :data-source="rows"
                    row-key="key"
                    :pagination="false"
                    :locale="{ emptyText: 'Nenhuma compra encontrada para este produto.' }"
                >
                    <template slot="marca" slot-scope="text, row">{{ row.brand || "—" }}</template>
                    <template slot="fornecedor" slot-scope="text, row">{{ row.providerName || "—" }}</template>
                    <template slot="dataCompra" slot-scope="text, row">{{ row.createdAt | formatDateOnly }}</template>
                    <template slot="cotacao" slot-scope="text, row">#{{ row.requestId }}</template>
                    <template slot="requisitante" slot-scope="text, row">{{ row.requestName || "—" }}</template>
                    <template slot="quantidade" slot-scope="text, row">{{ row.quantity }}</template>
                    <template slot="valorUnit" slot-scope="text, row">{{ row.unitPrice | customCurrency }}</template>
                    <template slot="valorTotal" slot-scope="text, row">{{ row.total | customCurrency }}</template>
                </a-table>
            </div>
        </div>
    </a-modal>
</template>

<script>
import OrderService from "@/services/v3/products/order.service";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import currencyPrecision from "@/mixins/currencyPrecision";

export default {
    name: "ProductOrdersModal",
    mixins: [currencyPrecision],
    props: {
        product_id: {
            type: Number,
            required: true,
        },
        product_name: {
            type: String,
        },
    },
    data() {
        return {
            loading: true,
            svc: new OrderService(),
            orders: [],
        };
    },
    computed: {
        columns() {
            return [
                { title: "Marca", key: "marca", scopedSlots: { customRender: "marca" } },
                { title: "Fornecedor", key: "fornecedor", scopedSlots: { customRender: "fornecedor" } },
                { title: "Data Compra", key: "dataCompra", align: "center", scopedSlots: { customRender: "dataCompra" } },
                { title: "Nº Cotação", key: "cotacao", align: "center", scopedSlots: { customRender: "cotacao" } },
                { title: "Requisitante", key: "requisitante", scopedSlots: { customRender: "requisitante" } },
                { title: "Quantidade", key: "quantidade", align: "right", scopedSlots: { customRender: "quantidade" } },
                { title: "Valor Unit.", key: "valorUnit", align: "right", scopedSlots: { customRender: "valorUnit" } },
                { title: "Valor Total", key: "valorTotal", align: "right", scopedSlots: { customRender: "valorTotal" } },
            ];
        },
        rows() {
            return this.orders.flatMap((order) =>
                (order.items || []).map((item) => ({
                    key: `${order.id}-${item.id}`,
                    brand: item.product ? item.product.brand : null,
                    providerName: order.provider ? order.provider.name : null,
                    createdAt: order.created_at,
                    requestId: order.request ? order.request.id : null,
                    requestName: order.request ? order.request.name : null,
                    quantity: item.quantity,
                    unitPrice: item.unit_price,
                    total: (item.packing_price || 0) * (item.quantity || 0),
                }))
            );
        },
    },
    created() {
        this.load_orders();
    },
    methods: {
        load_orders() {
            this.loading = true;

            this.svc
                .load_orders(this.product_id)
                .then((response) => {
                    this.orders = response.data;
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.poh-modal {
    max-height: 88vh;
    background: #fff;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.poh-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 18px 20px 14px;

    h3 {
        font-size: 16px;
        font-weight: 600;
        color: #262626;
        margin: 0;
    }
}
.poh-sub {
    font-size: 13px;
    color: #8c8c8c;
    margin-top: 2px;
}
.poh-x {
    width: 28px;
    height: 28px;
    border: none;
    background: none;
    border-radius: 6px;
    color: #8c8c8c;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: #f0f0f0;
        color: #262626;
    }
}
.poh-body {
    flex: 1;
    overflow-y: auto;
    padding: 0 20px 20px;
    border-top: 1px solid #f0f0f0;
}
</style>

<style lang="scss">
.poh-wrap {
    .ant-modal {
        max-width: 96vw;
    }

    .ant-modal-content {
        padding: 0;
        border-radius: 10px;
        overflow: hidden;
    }

    .ant-modal-body {
        padding: 0;
    }
}
</style>
